import { Text } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import React, { FC } from "react"
import { ImageSectionItem } from "./ImageSectionItem"
import clsx from "clsx"

const FourOrLessProjectsFragment = graphql(`
  fragment FourOrLessProjects on CreativeWorkPortfolioProjectConnection {
    edges {
      node {
        __typename
        id
        ...ImageSectionItem
      }
    }
  }
`)

interface Props {
  projects: FragmentType<typeof FourOrLessProjectsFragment> | undefined | null
  type: "grid" | "list"
  imageHeightClass: string
  imageWidthClass: string
  showTextOverlay: boolean
}

export const FourOrLessProjects: FC<Props> = props => {
  const { type, imageHeightClass, imageWidthClass, showTextOverlay } = props
  const projects = useFragment(FourOrLessProjectsFragment, props.projects)
  const edges = projects?.edges

  if (edges?.length === 1 && type === "list") {
    return (
      <div className={clsx("flex w-full flex-row gap-x-2", imageHeightClass)}>
        {edges?.map((edge, index: number) => {
          const project = edge?.node

          return (
            <ImageSectionItem
              fourOrLessProjects
              project={project}
              key={project?.id}
              index={index}
              imageHeightClass={imageHeightClass}
              imageWidthClass={imageWidthClass}
              showTextOverlay={showTextOverlay}
            />
          )
        })}
        <ImageSectionItem
          fourOrLessProjects
          project={undefined}
          key="blank"
          index={undefined}
          imageHeightClass={imageHeightClass}
          imageWidthClass={imageWidthClass}
          showTextOverlay={showTextOverlay}
        />
      </div>
    )
  }

  return (
    <div className={clsx("flex w-full flex-row gap-x-2", imageHeightClass)}>
      {edges?.map((edge, index: number) => {
        const project = edge?.node

        return (
          <ImageSectionItem
            fourOrLessProjects
            project={project}
            key={project?.id}
            index={index}
            imageHeightClass={imageHeightClass}
            imageWidthClass={imageWidthClass}
            showTextOverlay={showTextOverlay}
          />
        )
      })}
    </div>
  )
}
